import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CustomerStatData } from '../../../shared/types';
import { MobileDetectionMixin } from '../../../shared/mixins/mobile-detection.mixin';

@Component({
  selector: 'app-analytics-stats-card',
  standalone: true,
  imports: [CommonModule, MatTooltipModule],
  templateUrl: '../../../components/customer-stats-card/customer-stats-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./analytics-stats-card.component.scss'],
})
export class AnalyticsStatsCardComponent extends MobileDetectionMixin {
  @Input() data!: CustomerStatData;
}
